import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { getAllServices } from "../../Api";

const Solutions = ({ language = "EN" }) => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  const langKey = language === "CN" ? "zh" : "en";

  const text = {
    en: {
      subtitle: "SERVICES SNAPSHOT",
      title: "Comprehensive Protection for Every Stage of Life",
      desc:
        "Tailored strategies designed to protect, grow, and manage your wealth and business interests with precision and care.",
      learn: "Learn More",
      btn: "View All Services",
    },

    zh: {
      subtitle: "服务概览",
      title: "为人生每个阶段提供全面保障",
      desc:
        "量身定制的策略，帮助您保护、增长并管理财富与商业利益。",
      learn: "了解更多",
      btn: "查看所有服务",
    },
  };

  useEffect(() => {
    getAllServices()
      .then((res) => {
        if (res.data.success) {
          setServices(res.data.data);
        }
      })
      .catch((err) => {
        console.error("Solutions Fetch Error:", err);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="bg-[#EBEBEB] py-12">
      <div className="max-w-[1320px] mx-auto px-4 text-center">

        {/* Heading */}
        <p className="text-[#C69C6D] font-semibold tracking-wide">
          {text[langKey].subtitle}
        </p>

        <h2 className="text-3xl md:text-4xl font-medium text-[#154059] mt-3">
          {text[langKey].title}
        </h2>

        <p className="text-gray-500 mt-4 max-w-2xl mx-auto">
          {text[langKey].desc}
        </p>


        {/* Loading */}
        {loading && (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-10">
            {[1, 2, 3].map((item) => (
              <div key={item} className="bg-white p-8 animate-pulse">
                <div className="h-6 bg-gray-200 mb-4 w-1/2"></div>
                <div className="h-4 bg-gray-200 mb-2"></div>
                <div className="h-4 bg-gray-200 w-3/4"></div>
              </div>
            ))}
          </div>
        )}


        {/* Cards */}
        {!loading && (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-10">
            {services.slice(0, 6).map((item) => (
              <Link
                key={item._id}
                to={`/services/${item._id}`}
                className="relative bg-white p-8 text-left
                border-t-4 border-transparent
                hover:border-[#C2976C]
                transition-all duration-300
                overflow-hidden group block shadow-sm"
              >

                {item.icon && (
                  <img
                    src={`${process.env.REACT_APP_API_URL}/${item.icon?.replace(/\\/g, "/")}`}
                    alt=""
                    className="absolute right-6 top-6 w-24 opacity-0 object-contain
                    brightness-0 grayscale pointer-events-none
                    transition-all duration-300
                    group-hover:opacity-15"
                  />
                )}

                {item.icon && (
                  <div className="w-14 h-14 flex items-center justify-center rounded-full mb-6
                  bg-[#1f3a44] relative z-10">
                    <img
                      src={`${process.env.REACT_APP_API_URL}/${item.icon?.replace(/\\/g, "/")}`}
                      alt={item.title?.[langKey]}
                      className="w-6 h-6 object-contain brightness-0 invert"
                    />
                  </div>
                )}

                <h3 className="text-lg font-bold text-[#C2976C] mb-3 relative z-10">
                  {item.title?.[langKey]}
                </h3>

                <p className="text-gray-600 text-sm leading-relaxed relative z-10">
                  {item.content?.[langKey]?.[0]?.substring(0, 120)}...
                </p>

                <div className="mt-6 flex items-center text-sm font-semibold text-[#C2976C] relative z-10">
                  {text[langKey].learn}
                  <ArrowRight size={16} className="ml-2" />
                </div>

              </Link>
            ))}
          </div>
        )}


        {/* Button */}
        <div className="mt-10">
          <Link
            to="/services"
            className="inline-block bg-[#C2976C] text-white px-8 py-3 font-semibold hover:bg-[#a88257] transition-colors duration-300"
          >
            {text[langKey].btn}
          </Link>
        </div>

      </div>
    </section>
  );
};

export default Solutions;